import React, { Component } from "react";
import Label from "../../../components/atoms/Label";
import LabelWithText from "../../../components/molecules/LabelWithText";
import Button from "../../../components/atoms/Button";
const profilePic = "/img/icon/profil-icon.png";

const statusVA = ["DS1", "WD1"];
export default ({ data, openCaraTF }) => {
	let findStatus = statusVA.indexOf(data.loanStatus);
	let showVA = findStatus === -1 ? false : true;
	let { virtualAccount } = data;
	return (
		<div className="card-informasi-pinjaman">
			<div className="container-top">
				<img className="profil-picture" src={profilePic} />
				<p>
					<Label value="Status: " className="fontsize-status" />
					<Label value={data.loanProgress} className="fontsize-status blue label-kc-mb" />
				</p>
			</div>
			{showVA && virtualAccount && (
				<div className="container-middle text-left">
					<p className="initial-display title-va">DETIL VIRTUAL ACCOUNT</p>
					<div className="card-va">
						<Label value={"BNI Virtual Account"} className="label-kc-sb color-blue" />
						<Label value={virtualAccount.virtualAccountNumber} type={"paragraph"} className="label-kc-mb color-gray label-no-va" />
						<Label value={virtualAccount.virtualAccountName} className="color-gray label-name-va" />
						<div className="text-center btn-va">
							<Button title={"CARA PEMBAYARAN"} onClick={openCaraTF} type={"button"} color="blue" width="big" />
						</div>
					</div>
				</div>
			)}
			<div className="container-bottom">
				<LabelWithText label={"Kode Pinjaman"} text={data.loanCode} />
				<LabelWithText label={"Nama Peminjam"} text={data.companyName} />
				<LabelWithText label={"Nama Alias"} text={data.borrowerName} />
				<LabelWithText label={"Tujuan Pinjaman"} text={data.loanPurpose} />
				<LabelWithText label={"Tenor"} text={`${data.loanDuration} hari`} />
				<LabelWithText label={"Tipe Pinjaman"} text={data.nameProductMapping} />
			</div>
		</div>
	);
};
